import React, { Fragment, useEffect, useState } from 'react';
import { Popover, Transition } from '@headlessui/react';
import Notification from '../../Assets/Icons/notification';
import { ReactComponent as Profile } from '../../Assets/Icons/profile.svg';
import { useUserData } from '../../Services/hooks/User';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { userData } from '../../Storeredux/constants/actionTypes';
import Loader from '../Loader/Loader';

function Notifications() {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const { getNotification, notification, loading } = useUserData();
  console.log(notification, loading);
  const [hasFetched, setHasFetched] = useState(false); // Prevent refetching unnecessarily

  function getTimeFromISO(dateString: any) {
    // Create a Date object from the ISO string
    const date = new Date(dateString);

    // Extract the hours, minutes, and seconds
    const hours = String(date.getUTCHours()).padStart(2, '0'); // Ensure 2 digits
    const minutes = String(date.getUTCMinutes()).padStart(2, '0'); // Ensure 2 digits
    const seconds = String(date.getUTCSeconds()).padStart(2, '0'); // Ensure 2 digits

    // Format the time as HH:mm:ss
    return `${hours}:${minutes}:${seconds}`;
  }

  const handlePopoverOpen = () => {
    if (!hasFetched) {
      getNotification(user.id);
      setHasFetched(true);
    }
  };
  useEffect(() => {
    getNotification(user.id);
  }, []);
  return (
    <Popover className="relative">
      {({ open }) => {
        if (open) {
          handlePopoverOpen();
        } else {
          setHasFetched(false);
        }

        return (
          <>
            <Popover.Button
              className={`
                ${open ? 'text-white' : 'text-white/90'}
                group bg-custom-white rounded-full flex flex-col justify-center items-center w-10 text-base font-medium hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
            >
              <Notification />

            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                className="absolute right-0 mt-2 z-40 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5 "
                     style={{ width: '24rem', height: '24rem' }}>
                  <div className="p-3 h-full">
                    <h1 className="text-md text-center">Notification</h1>
                    { loading ? <div className='text-center justify-center items-center flex flex-col h-full'><Loader /></div> :
                      notification.length === 0 ?
                        <div className='text-center justify-center items-center flex flex-col h-full'><p>No
                          Notification</p></div>
                        :
                        notification.map((solution: any, index) => {
                          return (
                            <div key={index} className=" border-b border-custom-grey py-2 px-2">
                              <div className='flex justify-between pb-2'>
                                <div className='flex gap-2.5'>
                                  <div
                                    className='group rounded-full h-6 w-6 flex flex-col items-center justify-center bg-white border border-custom-purple overflow-hidden'>
                                    <Profile />
                                  </div>
                                  <p>Admin</p>
                                </div>
                                <p className='text-custom-grey text-xs'>{getTimeFromISO(solution.updated_at)}</p>
                              </div>
                              <div className='text-custom-grey bg-[#E9F5F0] py-2 px-2'>
                                <h1 className='text-sm'>{`Hi ${user.name}`}</h1>
                                <p className='text-xs'>
                                  {solution.data.message}.
                                </p>
                              </div>
                            </div>
                          );
                        })
                    }

                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        );
      }}
    </Popover>
  );
}

export default Notifications;
